import classnames from '@helpers/misc/classnames'

const renderLine = (label, value, className?) => (
  <div className={classnames('flex text-sm', className)}>
    <div className="flex-1 font-semibold">{label}</div>
    <div>{value}</div>
  </div>
)

export default renderLine
